import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const schema = z.object({
  returnUrl: z.string().optional()
})

export const EditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$licenseId/edit`,
    component: lazyRouteComponent(() => import('./EditLicense')),
    validateSearch: (search) => schema.parse(search)
  })
